import { getCompressedAssetUrl } from 'lib/config/assetUrls';

export type CaRetailerId = 'bestbuy' | 'costco';

export type CaRetailer = {
  id: CaRetailerId;
  url: string;
  logoSrc: string;
};

const UTM_PARAMS = {
  utm_source: 'ultrahuman',
  utm_medium: 'site-banner',
  utm_campaign: 'ca-promo-aug26',
} as const;

const withUtms = (baseUrl: string, retailer: CaRetailerId): string => {
  const url = new URL(baseUrl);
  Object.entries(UTM_PARAMS).forEach(([key, value]) => {
    url.searchParams.set(key, value);
  });
  url.searchParams.set('utm_content', retailer);
  return url.toString();
};

/** Outbound Best Buy link used by the Canada retail popup. */
export const BEST_BUY_RETAIL_POPUP_URL = withUtms(
  'https://www.bestbuy.ca/en-ca/product/ultrahuman-ring-air-smart-ring-with-health-sleep-fitness-6-day-battery-bionic-gold-size-8/18592572',
  'bestbuy',
);

export const CA_RETAILERS: CaRetailer[] = [
  {
    id: 'bestbuy',
    logoSrc: getCompressedAssetUrl(
      '/web_v2/ring-buy/ca-retail/best-buy-logo-117x80.jpeg',
    ),
    url: BEST_BUY_RETAIL_POPUP_URL,
  },
  {
    id: 'costco',
    logoSrc: getCompressedAssetUrl(
      '/web_v2/ring-buy/ca-retail/costco-logo.svg',
    ),
    url: withUtms(
      'https://www.costco.ca/s?keyword=Ultrahuman&refinement=brands%253DUltrahuman',
      'costco',
    ),
  },
];

/** Best Buy Canada has parallel en-ca / fr-ca product URLs; Costco search is language-agnostic. */
export function getCaRetailers(language: string = 'en'): CaRetailer[] {
  if (language !== 'fr') return CA_RETAILERS;

  return CA_RETAILERS.map((retailer) =>
    retailer.id === 'bestbuy'
      ? { ...retailer, url: retailer.url.replace('/en-ca/', '/fr-ca/') }
      : retailer,
  );
}
